import GridColumn from "./GridColumn/GridColumn";
import { HtmlElementProps } from "../../../types/globals";
import {
	AlignItemsProps,
	FlexDirectionProps,
	JustifyContentProps,
} from "styled-system";
import { BreakpointOptions } from "../../../types/theming";
import { SpaceOptionsOrZero } from "../Space/Space.types";

/**
 * All spatial values should be multiples of the GRID_BASELINE.
 */
export const GRID_BASELINE = 4; // px

export interface GridSubComponents {
	Column: typeof GridColumn;
}

/**
 * GridGuttersBreakpointKeys has not been implemented yet.
 * This is one for a future iteration of the Grid, to allow custom gutters per breakpoint. Used like...
 * <Grid gutters={ xs: "md", md: "lg "}>
 * which will use md sized gutters from viewport xs, swapping to lg gutters when md breakpoint is hit.
 * Currently, projects will have to manage this token swapping in their own code, with the useViewport hook.
 */
export type GridGuttersBreakpointKeys = {
	[key in BreakpointOptions]?: SpaceOptionsOrZero;
};

export type GridConditionalProps =
	| {
			gutters?: SpaceOptionsOrZero;
			rowGutters?: never;
			colGutters?: never;
	  }
	| {
			gutters?: never;
			rowGutters?: SpaceOptionsOrZero;
			colGutters?: SpaceOptionsOrZero;
	  };

/**
 * Props
 */
export type GridProps = Omit<HtmlElementProps, "htmlTag"> &
	AlignItemsProps &
	FlexDirectionProps &
	JustifyContentProps &
	GridConditionalProps & {
		/**
		 * Set fit to true if you would like the grid to auto-fit the available space. This sets
		 * width and height equal to 100%.
		 */
		fit?: boolean;
	};

/**
 * Styled Props
 */
export type StyledGridProps = Omit<
	GridProps,
	"gutters" | "rowGutters" | "colGutters"
> & {
	/**
	 * A resolved spacing gutter to apply left and right of columns.
	 */
	colGutters: SpaceOptionsOrZero;

	/**
	 * A resolved spacing gutter to apply between top and bottom of columns.
	 */
	rowGutters: SpaceOptionsOrZero;
};
